import { render } from "./user-permissions.vue?vue&type=template&id=075d8136"
import script from "./user-permissions.vue?vue&type=script&lang=js"
export * from "./user-permissions.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__